import React, { useState } from 'react';

import { Title } from '@mantine/core';
import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { AthleteRetrieve } from 'types';

import AthletePackageCreateForm from './components/AthletePackageCreateForm';
import AthletePackagesFilters from './components/AthletePackagesFilters';
import AthletePackagesTable from './components/AthletePackagesTable';
import { AthletePackageSearchFilters } from './types';

const Packages = ({
  athlete,
  permission = true,
}: {
  athlete: AthleteRetrieve;
  permission?: boolean;
}): JSX.Element => {
  const [isCreateFormOpened, { open, close }] = useDisclosure(false);
  const initialSearchFilters: AthletePackageSearchFilters = {
    statuses: ['ACTIVE', 'UPCOMING', 'HOLD'],
  };
  const [searchFilters, setSearchFilters] = useState<AthletePackageSearchFilters>(initialSearchFilters);
  const [debouncedSearchFilters] = useDebouncedValue<AthletePackageSearchFilters>(searchFilters, 250);

  return (
    <>
      <AthletePackagesFilters
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        handleOpenCreateForm={open}
        permission={permission}
      />
      <AthletePackagesTable
        athlete={athlete}
        permission={permission}
        searchFilters={debouncedSearchFilters}
      />
      <AthletePackageCreateForm
        athleteId={athlete.athleteId}
        title={<Title order={3}>Add Package</Title>}
        opened={isCreateFormOpened}
        closeHandler={close}
      />
    </>
  );
};

export default Packages;
